import { useMutation } from '@tanstack/react-query'
import { HttpStatusCode } from 'axios'

import type { TEnviarDocumentoParams } from '@/shared//envio-documentos'

import { EnviarDocumentoLeadService } from '../http/enviar-documentos-lead.service'
import { leadsRepresadosQueryKeys } from '../utils/query-keys'

export const useEnviarDocumentosLead = (clienteId: string) => {
  return useMutation({
    mutationKey: leadsRepresadosQueryKeys.envioDocumentosLead(),
    mutationFn: async ({
      arquivo,
      tipo,
      documentId,
    }: TEnviarDocumentoParams): Promise<{ sucesso: boolean; documentId: string }> => {
      const response = await new EnviarDocumentoLeadService().execute({ arquivo, tipo, clienteId })
      return { sucesso: response.status === HttpStatusCode.Ok, documentId }
    },
  })
}
